import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SensitiveStep_2Page } from './sensitive-step-2';
import {ComponentsModule} from "../../../components/components.module";

@NgModule({
  declarations: [
    SensitiveStep_2Page,
  ],
  imports: [
    IonicPageModule.forChild(SensitiveStep_2Page),
    ComponentsModule
  ],
})
export class SensitiveStep_2PageModule {}



// WEBPACK FOOTER //
// ./src/pages/sensitive/sensitive-step-2/sensitive-step-2.module.ts